import { UserManagement } from "~/components/admin/user-managament";

export const UserManagementScreen = () => {
  return <UserManagement />;
}; 
